// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import UserController from "./user_controller"
application.register("user", UserController)

import LineBrowserGateController from "./line_browser_gate_controller"
application.register("line-browser-gate", LineBrowserGateController)
